/* KUP Coffee & Brew Guide — tabs, roast slider, per-method brew calculator. */
(function(){
  'use strict';
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function boot(){
    var root = document.querySelector('[data-kg]');
    if(!root || root.dataset.kgBound === '1') return;
    root.dataset.kgBound = '1';

    /* ---------- Tabs ---------- */
    var tabs = [].slice.call(root.querySelectorAll('[data-kg-tab]'));
    var panels = [].slice.call(root.querySelectorAll('[data-kg-panel]'));
    function showTab(id){
      tabs.forEach(function(t){ t.setAttribute('aria-selected', t.getAttribute('data-kg-tab') === id ? 'true' : 'false'); });
      panels.forEach(function(p){ p.classList.toggle('is-active', p.getAttribute('data-kg-panel') === id); });
      try{ history.replaceState(null,'','#'+id); }catch(e){}
    }
    tabs.forEach(function(t){
      t.addEventListener('click', function(){ showTab(t.getAttribute('data-kg-tab')); });
      t.addEventListener('keydown', function(e){
        var i = tabs.indexOf(t);
        if(e.key === 'ArrowRight'){ e.preventDefault(); tabs[(i+1)%tabs.length].focus(); tabs[(i+1)%tabs.length].click(); }
        if(e.key === 'ArrowLeft'){ e.preventDefault(); tabs[(i-1+tabs.length)%tabs.length].focus(); tabs[(i-1+tabs.length)%tabs.length].click(); }
      });
    });
    // Deep links like /pages/coffee-guide#brew open the right view.
    var hash = (window.location.hash || '').replace('#','');
    if(hash && tabs.some(function(t){ return t.getAttribute('data-kg-tab') === hash; })) showTab(hash);

    /* ---------- Roast slider ----------
       Stops come from the DOM, so adding a fourth roast in the editor needs no
       code change: the slider simply divides the range by the number of stops. */
    var slider = root.querySelector('[data-kg-slider]');
    if(slider){
      var stops = [].slice.call(root.querySelectorAll('[data-roast]'));
      var swatch = root.querySelector('[data-kg-swatch]');
      var label  = root.querySelector('[data-kg-swatch-label]');
      var nameEl = root.querySelector('[data-kg-roast-name]');
      var descEl = root.querySelector('[data-kg-roast-desc]');
      var notesEl= root.querySelector('[data-kg-notes]');
      var ctaEl  = root.querySelector('[data-kg-cta]');
      var imgs   = [].slice.call(root.querySelectorAll('[data-roast-img]'));
      var current = -1;

      function applyRoast(i){
        if(i === current || !stops[i]) return;
        current = i;
        var d = stops[i].dataset;
        if(swatch && d.color) swatch.style.background = d.color;
        if(label) label.textContent = d.name || '';
        if(nameEl) nameEl.textContent = d.name || '';
        if(descEl) descEl.textContent = d.desc || '';
        if(notesEl){
          notesEl.innerHTML = '';
          (d.notes || '').split(',').forEach(function(n){
            n = n.trim(); if(!n) return;
            var li = document.createElement('li'); li.textContent = n; notesEl.appendChild(li);
          });
        }
        if(ctaEl){
          if(d.url){ ctaEl.hidden = false; ctaEl.href = d.url; ctaEl.firstChild.textContent = (d.cta || 'Shop this roast') + ' '; }
          else ctaEl.hidden = true;
        }
        imgs.forEach(function(im, k){ im.classList.toggle('is-on', k === i); });
      }

      function fromValue(){
        var n = stops.length || 1;
        var idx = Math.min(n - 1, Math.floor((+slider.value / 100) * n));
        applyRoast(idx);
      }
      slider.addEventListener('input', fromValue);
      fromValue();
    }

    /* ---------- Brew methods + calculator ---------- */
    var methods = [].slice.call(root.querySelectorAll('[data-method]'));
    if(methods.length){
      var recipes = [].slice.call(root.querySelectorAll('[data-recipe]'));
      var water = root.querySelector('[data-kg-water]');
      var ratio = root.querySelector('[data-kg-ratio]');
      var waterV = root.querySelector('[data-kg-water-val]');
      var ratioV = root.querySelector('[data-kg-ratio-val]');
      var out = root.querySelector('[data-kg-out]');
      var outSub = root.querySelector('[data-kg-out-sub]');
      var split = root.querySelector('[data-kg-split]');
      var active = null;

      function recalc(){
        if(!water || !ratio || !active) return;
        var w = +water.value, r = +ratio.value;
        if(waterV) waterV.textContent = w;
        if(ratioV) ratioV.textContent = r;
        if(out) out.textContent = Math.round(w / r);

        var cups = Math.max(1, Math.round(w / 150));
        if(outSub) outSub.textContent = 'about ' + cups + (cups === 1 ? ' cup' : ' cups');

        // Flash brew: part of the water goes in as ice.
        var icePct = parseFloat(active.dataset.ice || '0');
        if(split){
          if(icePct > 0){
            split.hidden = false;
            split.textContent = 'Hot water ' + Math.round(w * (1 - icePct/100)) + ' ml  ·  Ice ' + Math.round(w * icePct/100) + ' g';
          } else split.hidden = true;
        }
      }

      function selectMethod(el){
        active = el;
        methods.forEach(function(m){ m.setAttribute('aria-selected', m === el ? 'true' : 'false'); });
        var id = el.getAttribute('data-method');
        recipes.forEach(function(r){ r.hidden = r.getAttribute('data-recipe') !== id; });

        var d = el.dataset;
        if(ratio){
          ratio.min = d.ratioMin || 12;
          ratio.max = d.ratioMax || 18;
          ratio.value = d.ratioDef || 16;
        }
        if(water){
          water.min = d.waterMin || 150;
          water.max = d.waterMax || 1200;
          if(+water.value < +water.min || +water.value > +water.max) water.value = d.waterDef || 500;
        }
        recalc();
      }

      methods.forEach(function(m){ m.addEventListener('click', function(){ selectMethod(m); }); });
      if(water) water.addEventListener('input', recalc);
      if(ratio) ratio.addEventListener('input', recalc);
      selectMethod(methods[0]);
    }
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function(){
    var r = document.querySelector('[data-kg]');
    if(r) r.dataset.kgBound = '';
    boot();
  });
})();
